import styled from 'styled-components';

export const BadgesStyles = styled.div`
  margin-top: auto;
  margin-bottom: 4px;

  .truckmarket-badge {
    margin-right: 8px;
  }
`;
